module.exports = __webpack_public_path__ + "static/media/dodatki-ekstra-icon.1548b193.svg";